import { useMutation, useQueryClient } from '@tanstack/react-query';
import { loaders } from './permissions.loaders';
import { permissionsKeys } from './permissions.queries';

export const useCreateRole = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createRole, {
    onSuccess: () => {
      return queryClient.invalidateQueries(permissionsKeys.all);
    },
  });
};

export const useUpdateRole = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateRole, {
    onSuccess: () => {
      return queryClient.invalidateQueries(permissionsKeys.all);
    },
  });
};

export const useDeleteRole = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.deleteRole, {
    onSuccess: () => {
      return queryClient.invalidateQueries(permissionsKeys.lists);
    },
  });
};

export const useCopyRole = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.copyRole, {
    onSuccess: () => {
      return queryClient.invalidateQueries(permissionsKeys.lists);
    },
  });
};

export const useBulkUpdateRolePermissions = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.bulkUpdateRolePermissions, {
    onSuccess: () => {
      return queryClient.invalidateQueries(permissionsKeys.all);
    },
  });
};
